import Model from '@/models/Model.js';

export default class ViewInformationActivityTemplate extends Model {
    static entity = 'view_information_activity_templates';

    static modelName = 'ViewInformationActivityTemplate';

    static fields() {
        return {
            content: this.attr(null),

            ...super.fields(),
        };
    }
}
